import React from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { FileText, Image as ImageIcon, Loader2, Share2, X } from 'lucide-react';
interface SharePromptPopupProps {
  isOpen: boolean;
  onClose: () => void;
  onDownloadPDF: () => void;
  onDownloadImage: () => void;
  onOpenShareOptions: () => void;
  isGeneratingPDF: boolean;
  isGeneratingImage: boolean;
}
export function SharePromptPopup({
  isOpen,
  onClose,
  onDownloadPDF,
  onDownloadImage,
  onOpenShareOptions,
  isGeneratingPDF,
  isGeneratingImage
}: SharePromptPopupProps) {
  return <AnimatePresence data-id="element-589" data-mp="oposbtikuo9s">
      {isOpen && <motion.aside role="dialog" aria-labelledby="share-prompt-title" aria-describedby="share-prompt-desc" initial={{
      opacity: 0,
      y: 16,
      scale: 0.96
    }} animate={{
      opacity: 1,
      y: 0,
      scale: 1
    }} exit={{
      opacity: 0,
      y: 16,
      scale: 0.96
    }} transition={{
      duration: 0.22,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed bottom-4 left-4 right-4 z-[60] border border-red-500/40 bg-[#050505] p-5 shadow-2xl sm:left-auto sm:right-6 sm:bottom-6 sm:w-[380px]" data-id="element-590" data-mp="12nvguj1mzbws">
          <div className="absolute left-0 top-0 h-1 w-full bg-[#FF0000]" data-id="element-591" data-mp="zeqmwf3dxbpp" />
          <button type="button" onClick={onClose} aria-label="Dismiss share prompt" className="absolute right-3 top-3 rounded p-1.5 text-gray-500 transition-colors duration-150 ease-out hover:text-white focus:outline-none focus:ring-2 focus:ring-[#FF0000]" data-id="element-592" data-mp="14c8tvzxudgv2">
            <X size={16} data-id="element-593" data-mp="1i33ukoy6srnk" />
          </button>

          <div className="flex items-start gap-3 pr-6" data-id="element-594" data-mp="1n41cd0fabjoj">
            <div className="flex h-9 w-9 flex-shrink-0 items-center justify-center rounded-full border border-red-500/40 bg-red-500/10" data-id="element-595" data-mp="1n4b711b9yf0k">
              <Share2 size={16} className="text-[#FF0000]" aria-hidden="true" data-id="element-596" data-mp="3ov4qw0sapied" />
            </div>
            <div data-id="element-597" data-mp="3tu7vxl89zomc">
              <h2 id="share-prompt-title" className="text-base font-black uppercase tracking-tight text-white" data-id="element-598" data-mp="3ttpqpz3my02a">
                Share your results
              </h2>
              <p id="share-prompt-desc" className="mt-1 text-sm leading-relaxed text-gray-400" data-id="element-599" data-mp="3hspym7bys7ow">
                Keep a copy or show someone you trust what the scan found.
              </p>
            </div>
          </div>

          <div className="mt-4 grid grid-cols-2 gap-2" data-id="element-600" data-mp="8n0119qkaa6k">
            <button type="button" onClick={onDownloadPDF} disabled={isGeneratingPDF} className="flex items-center justify-center gap-2 border border-gray-800 bg-[#0a0a0a] px-3 py-2.5 text-xs font-bold uppercase tracking-wide text-white transition-colors duration-150 ease-out hover:border-gray-600 disabled:opacity-60" data-id="element-601" data-mp="8lgnvs07cf90">
              {isGeneratingPDF ? <Loader2 size={14} className="animate-spin" data-id="element-602" data-mp="s8mnlporyaqh" /> : <FileText size={14} data-id="element-603" data-mp="ndqt8iw2fba7" />}
              PDF
            </button>
            <button type="button" onClick={onDownloadImage} disabled={isGeneratingImage} className="flex items-center justify-center gap-2 border border-gray-800 bg-[#0a0a0a] px-3 py-2.5 text-xs font-bold uppercase tracking-wide text-white transition-colors duration-150 ease-out hover:border-gray-600 disabled:opacity-60" data-id="element-604" data-mp="16yhc76rnnpsl">
              {isGeneratingImage ? <Loader2 size={14} className="animate-spin" data-id="element-605" data-mp="s0f88vgpp2at" /> : <ImageIcon size={14} data-id="element-606" data-mp="s2jl42wl9bn8" />}
              Image
            </button>
            <button type="button" onClick={onOpenShareOptions} className="col-span-2 flex items-center justify-center gap-2 bg-[#FF0000] px-3 py-2.5 text-xs font-bold uppercase tracking-wide text-white transition-colors duration-150 ease-out hover:bg-red-700" data-id="element-607" data-mp="e6xnx8g7bljq">
              <Share2 size={14} data-id="element-608" data-mp="1ckv5lw6cqd59" />
              Share to socials
            </button>
          </div>
        </motion.aside>}
    </AnimatePresence>;
}